import { render, staticRenderFns } from "./SimpleSidebar.vue?vue&type=template&id=166e7178&lang=pug"
import script from "./SimpleSidebar.vue?vue&type=script&lang=js"
export * from "./SimpleSidebar.vue?vue&type=script&lang=js"
import style0 from "./SimpleSidebar.vue?vue&type=style&index=0&id=166e7178&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports